<script>
  import {beta} from '../../../../lib/beta/beta';
  import {faceTrackingStore} from '../../../../store';
  import FaceTracker from '../../../face-tracker/FaceTracker.svelte';
  import FaceTrackerProgress from '../../../face-tracker/FaceTrackerProgress.svelte';
</script>

<div class="mb-1 mt-3 flex items-center rounded-md">
  <div class="block" id="ai-camera-crew-div">
    <span class="text-sm font-bold">AI Camera Crew V2.0</span>
    <div class="inline-block">
      <span
        class="ml-1.5 mt-0.5 block rounded-full bg-secondary bg-opacity-40 px-2 py-0.5 font-secondary text-xs font-bold text-secondary-600"
        >NEW</span
      >
    </div>
  </div>
  <div class="ml-auto block">
    <FaceTracker />
  </div>
</div>

<div class="my-2">
  {#if $faceTrackingStore.loading}
    <FaceTrackerProgress />
  {/if}
</div>
